export default "__VITE_ASSET__D9HrQSky__"